class StickyObserver {
	constructor( el, callback, options = {} ) {
		this.el = el;
		this.callback = callback;
		this.options = options;

		this.start();
	}

	start() {
		this.stop();

		const style = getComputedStyle( this.el );
		const rootMargin = ( ['top', 'right', 'bottom', 'left'] ).map( ( side ) =>
			style[side] === 'auto' || !style[side]
				? '100%'
				: `${-1 * parseInt( style[side] ) - 1}px`,
		).join( ' ' );

		this.observer = new IntersectionObserver(
			( entries ) => {
				this.callback(
					!entries[entries.length - 1].isIntersecting,
					this.el,
				);
			},
			{
				threshold: [1],
				rootMargin,
				root: this.options.root,
			},
		);

		this.observer.observe( this.el );
	}

	stop() {
		this.observer?.disconnect();
	}
}

export default StickyObserver;
